var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-menu",
        {
          attrs: {
            "max-height": "40%",
            "max-width": "30%",
            "close-on-content-click": false,
            "nudge-width": 200,
            "offset-x": "",
            bottom: ""
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            small: "",
                            dark: "",
                            color:
                              _vm.valuesList.filter(function(item) {
                                return item.enable ? true : false
                              }).length > 0
                                ? "deep-purple darken-3"
                                : _vm.bgcolor
                          }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
                      _vm._l(
                        _vm.valuesList.filter(function(item) {
                          return item.enable ? true : false
                        }),
                        function(item, index) {
                          return _c("span", { key: index }, [
                            index <= 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n                 : " +
                                      _vm._s(item["value"]) +
                                      " \n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            index == 1
                              ? _c("span", [
                                  _vm._v(
                                    "\n                [+" +
                                      _vm._s(
                                        _vm.valuesList.filter(function(item) {
                                          return item.enable ? true : false
                                        }).length - 1
                                      ) +
                                      "] \n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        }
                      )
                    ],
                    2
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.menu,
            callback: function($$v) {
              _vm.menu = $$v
            },
            expression: "menu"
          }
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c("v-text-field", {
                staticClass: "pa-2 pb-0",
                attrs: {
                  outlined: "",
                  color: _vm.textFieldOutline,
                  label: "Search"
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm._l(_vm.filteredItems, function(item1, index) {
                return _c(
                  "v-list-item",
                  { key: index },
                  [
                    _c("v-checkbox", {
                      attrs: { label: item1["value"] },
                      on: { click: _vm.emitvaluesList },
                      model: {
                        value: item1["enable"],
                        callback: function($$v) {
                          _vm.$set(item1, "enable", $$v)
                        },
                        expression: "item1['enable']"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }